export function getPhoneDataFromString(phone?: string) {
    const arr = phone ? phone.split(" ") : [];
    const code = parseInt(arr[0], 10);
    const num = arr[1];

    return {
        code: isFinite(code) ? code : 48,
        number: !!num ? num : ""
    };
}
export function getPhoneDataFromString(phone?: string) {
    const arr = phone ? phone.split(" ") : [];
    const code = parseInt(arr[0], 10);
    const num = arr[1];

    return {
        code: isFinite(code) ? code : 48,
        number: !!num ? num : ""
    };
}
